import { Container } from "react-bootstrap";

const Footer = () => {
    return (
        <footer className="text-center" style={{borderTop: "2px solid black"}}>
            <Container style={{paddingTop: "1em", paddingBottom: '1em'}}>
                Honors Carolina Resume App<br></br>
                Saurav Bahali, Charles Chow, Habib Khadri, and Rahul Narvekar
            </Container>
        </footer>
    )
}
export default Footer;